import { reduce } from './reduce';
import { Collection } from './../types/collection';

/**
 * Takes a function of type `A -> void` and a [[Collection]] of type `F<A>`, executes the function on each element, and returns he collection.
 * NB `fn` should mutate `A` (hence its type); for immutable operations use [[map]].
 *
 * ```ts
 * tt.each((x) => {
 * x['b'] = x.a + 1;
 * }, [{a: 1}, {a: 2}, {a: 3}]);
 * // => [{a: 1, b: 2}, {a: 2, b: 3}, {a: 3, b: 4}]
 * ```
 * @param fn The function to apply; takes the object as the first parameter and key/index as the second.
 */
export function each<A>(fn: (a: A, keyOrIndex?: number | string) => void, f: Collection<A>): Collection<A> {
  reduce(
    (acc, x, i) => {
      fn(x, i);
      return acc;
    },
    [],
    f
  );
  return f;
}
